import React from "react";
import "../css/aside-sect.css";
import TeacherImg from "../assets/images/teacher.png";
import { ReactComponent as OrangeDash } from "../assets/icons/aside/orange-line.svg";
import Person1 from "../assets/icons/aside/person1.png";
import Person2 from "../assets/icons/aside/person2.png";
import Person3 from "../assets/icons/aside/person3.png";
import Person4 from "../assets/icons/aside/person4.png";

const Aside = () => {
  return (
    <section id="aside-sect">
      <div>
        <img src={TeacherImg} alt="a teacher folding her arms" />
        <div>
          <h4>Join other teachers on LMS earn 10x your salary in a week</h4>
          <OrangeDash id="orange-line" />
          <div>
            <div id="people">
              <img src={Person1} alt="" />
              <img src={Person2} alt="" />
              <img src={Person3} alt="" />
              <img src={Person4} alt="" />
              <span>+23k</span>
            </div>
            <span>teachers like you are on LMS right now</span>
          </div>
          <button>Learn more</button>
        </div>
      </div>
    </section>
  );
};

export default Aside;
